<template>
  <a-spin id="LookReport" :spinning="boxSpinning">
    <a-card title="基本信息" :bordered="false">
      <a-page-header style="border: 1px solid rgb(235, 237, 240); margin-bottom: 30px" :title="reportInfo.name"
                     :backIcon="false">
        <template slot="extra">
          <a-button v-if="!reportInfo.wordReportUrl && reportInfo.status === 1" type="link" key="3"> 报告生成中</a-button>
          <a-button v-if="reportInfo.wordReportUrl && reportInfo.status === 2" type="primary" ghost key="2">
            <a download :href="reportInfo.wordReportUrl | filterUrl">下载报告</a>
          </a-button>
          <a-button @click="copyGroupReport" key="1"> 拷贝报告</a-button>
        </template>
        <a-descriptions size="small" :column="3">
          <a-descriptions-item label="报告类型">
            {{ reportTypes[reportInfo.reportType] }}
          </a-descriptions-item>
          <a-descriptions-item label="机构名称">
            {{ reportInfo.organizationName }}
          </a-descriptions-item>
          <a-descriptions-item label="报告日期">
            {{ reportInfo.reportDate }}
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">
            {{ reportInfo.createTime }}
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
    </a-card>
    <a-card title="项目信息" :bordered="false">
      <StepsSecond />
    </a-card>
    <a-card title="能力配置" :bordered="false">
      <StepsThird />
    </a-card>
  </a-spin>
</template>

<script>
import StepsSecond from "../createReport/steps/StepsSecond";
import StepsThird from "../createReport/steps/StepsThird";


export default {
  name: "LookReport",
  components: { StepsSecond, StepsThird },
  props: {
    reportInfo: Object,
  },
  provide: {
    view: true,
  },
  data() {
    return {
      boxSpinning: false,
      reportTypes: ["", "单校团体训练报告"],
    };
  },
  mounted() {
    console.log(this.reportInfo);
  },
  methods: {
    //拷贝报告
    copyGroupReport() {
      this.$http.ReportService.GroupTrainingReportCopy(this.reportInfo.id).then((res) => {
        this.$message.success(res.message);
        this.$bus.$emit("copyTrainingReport", res.data);
      });
    },
  },
};
</script>

<style lang="less" scoped>
#LookReport {
  height: calc(100vh - 105px);
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}
</style>
